import React, { useMemo } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip,
} from '@mui/material';
import { FaFileCode } from 'react-icons/fa';
import { resolveSectionColumns, formatCellValue } from '../../../utils/ingestionSyncRuns';
import { TableWrapper, LinkButton } from './styles';

const ItemsTable = ({
  run, sectionKey, items, onNavigateToEmployee, onViewRecord,
}) => {
  const columns = useMemo(() => resolveSectionColumns({
    provider: run?.provider,
    syncType: run?.syncType,
    sectionKey,
    resultSchemaVersion: run?.resultSchemaVersion,
    items,
  }), [run?.provider, run?.syncType, run?.resultSchemaVersion, sectionKey, items]);

  return (
    <TableWrapper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Individual</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Source id</TableCell>
              {columns.map((column) => (
                <TableCell key={column.path}>{column.label}</TableCell>
              ))}
              {onViewRecord && <TableCell align="right">Record</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.id} hover>
                <TableCell>
                  {item.radarEmployeeId ? (
                    <LinkButton type="button" onClick={() => onNavigateToEmployee(item.radarEmployeeId)}>
                      {item.label || item.email || 'Open individual'}
                    </LinkButton>
                  ) : (item.label || '—')}
                </TableCell>
                <TableCell>{item.email || '—'}</TableCell>
                <TableCell>{item.sourceId || '—'}</TableCell>
                {columns.map((column) => (
                  <TableCell key={column.path}>{formatCellValue(item.preview?.[column.path])}</TableCell>
                ))}
                {onViewRecord && (
                  <TableCell align="right">
                    <Tooltip arrow title="View the full stored record">
                      <IconButton size="small" onClick={() => onViewRecord(item)}>
                        <FaFileCode size={14} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </TableWrapper>
  );
};

export default ItemsTable;
